
import React from "react";
import { Loader } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  className?: string;
  size?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className,
  size = 20,
}) => {
  return (
    <Loader
      className={cn("animate-spin", className)}
      size={size}
      aria-hidden="true"
    />
  );
};
